export const ConsumerAssetSubtypeErrorStyles = {
    errorMessage: 'my-4',
}